module.exports = __webpack_public_path__ + "img/dajiang.00105bde.png";